/**
 * Raid sim RNG — thin aliases over engine `src/sim/rng.ts`.
 * E1: sim (`rng`) and cosmetic bark (`cosmeticRng`) stay separate streams.
 */
import {
  cosmeticRandom,
  simRandom,
  withCosmeticRng,
  withSimRng,
  type SimRng,
} from "../../sim/rng";

export type RaidRng = SimRng;

export function withRaidRng<T>(rng: RaidRng, fn: () => T): T {
  return withSimRng(rng, fn);
}

export function withRaidCosmeticRng<T>(rng: RaidRng, fn: () => T): T {
  return withCosmeticRng(rng, fn);
}

export function raidRandom(state?: { rng?: RaidRng } | null): number {
  return simRandom(state);
}

export function raidCosmeticRandom(
  state?: { cosmeticRng?: RaidRng } | null,
): number {
  return cosmeticRandom(state);
}
